import React from "react";
import "./LoginEcosystem.css";

// Presentation only: this illustration does not send or read business data.
export default function LoginEcosystem() {
  return (
    <div className="login-ecosystem">
      <svg viewBox="0 65 610 575" role="group" aria-label="Kalo nga arka klasike në arkën tonë digjitale. Arka digjitale dërgon kuponin në printer dhe të dhënat në ATK dhe Accountree, ku menaxhohen shitjet, stoku, financat dhe raportet.">
        <g className="login-ecosystem__replacement">
          <text x="204" y="130" textAnchor="middle" fontSize="11">Kalo në digjitale</text>
          <path d="M154 155H254M245 146l9 9-9 9" fill="none" stroke="#ffc66d" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
        </g>
        <g fill="none" stroke="#8fcbb2" strokeWidth="1.5">
          <path className="login-ecosystem__connection" d="M274 190H235V280H451V325M278 280V315" />
          <path className="login-ecosystem__connection" d="M389 155H592V440H440" />
          <path className="login-ecosystem__connection" d="m273 309 5 6 5-6M446 319l5 6 5-6M448 433l-8 7 8 7" />
          <path className="login-ecosystem__branches" transform="translate(65 0)" d="M310 468V488H236V611M236 506H255M236 541H255M236 576H255M236 611H255" />
          <path pathLength="100" className="login-ecosystem__packet login-ecosystem__packet--printer" d="M274 190H235V280H278V315" />
          <path pathLength="100" className="login-ecosystem__packet login-ecosystem__packet--atk" d="M274 190H235V280H451V325" />
          <path pathLength="100" className="login-ecosystem__packet login-ecosystem__packet--accountree" d="M389 155H592V440H440" />
          {[506, 541, 576, 611].map((y, index) => (
            <path key={y} pathLength="100" className="login-ecosystem__packet login-ecosystem__packet--module"
              transform="translate(65 0)" d={`M310 468V488H236V${y}H255`}
              style={{ animationDelay: `${4.5 + index * 0.7}s` }} />
          ))}
        </g>

        <g transform="translate(-22 0)">
          <text x="99" y="85" className="login-ecosystem__muted" textAnchor="middle">ARKA KLASIKE</text>
          <g className="login-ecosystem__receipt">
            <path d="M77 100H122V137L117 133 111 137 105 133 99 137 93 133 87 137 81 133 77 137Z" fill="#dce5e1" />
            <path d="M85 109H114M85 116H108M85 123H114" stroke="#83958c" strokeWidth="2" />
          </g>
          <rect x="53" y="135" width="93" height="49" rx="8" fill="#e7a65a" />
          <rect x="62" y="143" width="37" height="16" rx="3" fill="#263e35" />
          <text x="80" y="155" className="login-ecosystem__screen-value" fill="#d5e4dc" fontSize="10" textAnchor="middle">12.50</text>
          {[0, 1, 2].map((row) => [0, 1, 2].map((col) => <rect key={`${row}-${col}`} x={108 + col * 10} y={144 + row * 10} width="6" height="6" rx="1.5" fill="#fff0d7" />))}
          <rect x="46" y="182" width="107" height="16" rx="5" fill="#f8cc86" />
          <path d="M84 190H114" stroke="#835121" strokeWidth="3" strokeLinecap="round" />
          <text x="99" y="224" className="login-ecosystem__label" textAnchor="middle">Printon kuponin</text>
          <text x="99" y="241" className="login-ecosystem__muted" textAnchor="middle">Procesi mbaron këtu</text>
        </g>

        <g className="login-ecosystem__destination login-ecosystem__destination--printer" transform="translate(40 300)">
          <g className="login-ecosystem__printer-receipt">
            <path d="M227 22H249V39H227Z" fill="#e5f8eb" />
            <path d="M231 27H245M231 32H242" stroke="#628773" strokeWidth="1.5" />
          </g>
          <rect x="223" y="36" width="30" height="17" rx="4" fill="#b8a0fa" />
          <path d="M229 47H247V61L243 58 239 61 235 58 229 61Z" fill="#e5f8eb" />
          <text x="259" y="40" className="login-ecosystem__label">Printeri</text>
          <text x="259" y="56" className="login-ecosystem__muted">Kuponi</text>
        </g>
        <a className="login-ecosystem__digital" transform="translate(60 0)" href="https://arkadigjitale.com" target="_blank" rel="noopener noreferrer" aria-label="Vizito Arkën Digjitale (hapet në tab të ri)">
          <rect x="214" y="99" width="115" height="112" rx="19" fill="#126e67" stroke="#6ff5d5" strokeWidth="1.5" />
          <rect x="236" y="115" width="71" height="64" rx="8" fill="#d9f9e7" />
          <rect x="244" y="123" width="55" height="11" rx="3" fill="#67dcbf" />
          <path d="m258 151 9 9 17-18" fill="none" stroke="#2b7754" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M263 181V190M280 181V190M252 192H291" fill="none" stroke="#6ff5d5" strokeWidth="4" strokeLinecap="round" />
          <circle cx="315" cy="111" r="4" fill="#b7f9cd" />
          <text x="272" y="234" className="login-ecosystem__label" textAnchor="middle">Arka Digjitale ↗</text>
          <text x="272" y="251" className="login-ecosystem__muted" textAnchor="middle">Kupon + të dhëna të lidhura</text>
        </a>

        <g className="login-ecosystem__destination login-ecosystem__destination--atk" transform="translate(35 285)">
          <path d="m404 58 12-7 12 7M406 62H426M409 63V76M416 63V76M423 63V76M404 79H428" fill="none" stroke="#2581ad" strokeWidth="2.5" strokeLinecap="round" />
          <text x="440" y="62" className="login-ecosystem__brand" fill="#7dd3fc">ATK</text>
          <text x="440" y="80" className="login-ecosystem__muted">Të dhënat fiskale</text>
        </g>
        <g className="login-ecosystem__destination login-ecosystem__destination--accountree" transform="translate(-135 212)">
          <circle cx="401" cy="222" r="5" fill="#b4e7ca" />
          <text x="414" y="228" className="login-ecosystem__brand" fill="#17543f">Accountree</text>
          <text x="397" y="247" fontSize="11" fill="#294e42">Biznesi yt, në një vend</text>
        </g>

        <g className="login-ecosystem__modules" transform="translate(-325 220)">
          {[
            { y: 286, label: "Shitjet", color: "#126b9b", icon: "M-9 4V-2M0 4V-9M9 4V-15" },
            { y: 321, label: "Stoku", color: "#97500b", icon: "m-10-10 10-5 10 5v14L0 9-10 4Zm0 0L0-5l10-5M0-5V9" },
            { y: 356, label: "Financat", color: "#147347", icon: "M-11-10H10V7H-11ZM4-4H12V2H4Z" },
            { y: 391, label: "Raportet", color: "#7442b0", icon: "M-9 8V-13H5L10-8V8ZM-4-5H5M-4 0H5" },
          ].map(({ y, label, icon, color }) => (
            <g key={label}>
              <path d={icon} transform={`translate(663 ${y})`} fill="none" stroke={color} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
              <text x="689" y={y + 4} fill={color} className="login-ecosystem__muted">{label}</text>
            </g>
          ))}
        </g>
      </svg>
    </div>
  );
}
